<template>
    <SvgIcon :symbol-data="symbolData"/>
</template>
<script lang="ts">
import {computed, defineComponent} from 'vue';
import icons, {enumIconName, SvgSymbolData} from '../icons';
import SvgIcon from './SvgIcon.vue';

export default defineComponent({
    components: {SvgIcon},
    props: {
        dataParameter: {required: true, type: String},
        dataOption: {required: true, type: String},
    },
    setup(props) {
        const symbolData = computed<SvgSymbolData>(() => {
            const iconName = enumIconName(props.dataParameter, props.dataOption);

            if (! (iconName in icons)) {
                throw new Error(`Icon ${iconName} was not found`);
            }

            return icons[iconName as keyof typeof icons] as SvgSymbolData;
        });

        return {symbolData};
    },
});
</script>

